import { useEffect, useState } from "react";
import { IMAGES } from "../../../../assets";
import { useInView } from "react-intersection-observer";

const Features = () => {
  const [leftRef, inLeftView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [upRef, inUpView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  return (
    <section className="basic-feature" id="basic-feature">
      <div className="container">
        <div className="row">
          <div ref={leftRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 ${inLeftView ? 'animate__animated animate__slideInLeft' : ''}`}>
            <div className="feature_wrapperleft">
              <figure className="mb-0 feature-circle">
                <img className="img-fluid" src={IMAGES.feature_circle} alt="" />
              </figure>
              <figure className="mb-0 featurephoneback">
                <img src={IMAGES.featurephoneback_img} alt="" />
              </figure>
              <figure className="mb-0 featurephone">
                <img
                  className="img-fluid"
                  src={IMAGES.featurephone_img}
                  alt=""
                />
              </figure>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="feature_wrapperright">
              <div className="feature_content">
                <h4>Our Features</h4>
                <h2>Gain Cosmic Clarity for Earthly Decisions</h2>
              </div>
              <div ref={upRef} className={`feature_lowercontent ${inUpView ? 'animate__animated animate__slideInUp' : ''}`} data-aos="fade-up">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="feature-box">
                      <figure className="feature-marketicon">
                        <img
                          src={IMAGES.astrologer}
                          alt=""
                          className="img-fluid"
                        />
                      </figure>
                      <h6>Certified Astrologer</h6>
                      <p className="text-size-18 mb-0">
                        Certified professionals with deep expertise in Vedic and Indian astrology, ready to illuminate your path with authentic insights.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="feature-design">
                      <div className="feature-box">
                        <figure className="feature-graphicon feature-box-2">
                          <img src={IMAGES.chat} alt="" className="img-fluid" />
                        </figure>
                        <h6>Connect with Chat</h6>
                        <p className="text-size-18 mb-0">
                          Have a question or need clarity? Instantly connect with astrologers via secure chat and receive personalized advice anytime, anywhere.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="feature-downcontent">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="feature-box">
                        <figure className="feature-graphicon feature-box-3">
                          <img src={IMAGES.call} alt="" className="img-fluid" />
                        </figure>
                        <h6>Call with Astrologers</h6>
                        <p className="text-size-18 mb-0">
                          Speak directly with experienced astrologers for real-time guidance on life issues. Your answers are just a call away.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="feature-design feature-guide">
                        <div className="feature-box">
                          <figure className="feature-guideicon feature-box-4">
                            <img
                              src={IMAGES.horoscope}
                              alt=""
                              className="img-fluid"
                            />
                          </figure>
                          <h6>Daily Horoscope</h6>
                          <p className="text-size-18 mb-0">
                            Start your day with cosmic clarity. Explore your personalized daily horoscope and align your actions with the universe’s rhythm.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
